import classNames from 'classnames';
import kjua from 'kjua';
import React, { useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../utils/layout-defaults';

// const bgColor = '#f7f7f7';
// const bgColor = 'transparent';

function QRCode({ className, payload, onClick }) {
  const classes = useStyles();
  const ref = useRef();

  useEffect(() => {
    const el = kjua({
      text: payload,
      rounded: 100,
      fill: '#222',
      back: layoutDefaults.cardColor,
      quiet: 0,
      //   mode: "label",

      //   label: "Pix",
      //   fontname: "Roboto",
      //   fontcolor: "red",

      //   mSize: 10,
      size: 150,
    });
    const { current } = ref;
    current.appendChild(el);

    return () => {
      current.removeChild(el);
    };
  }, [payload]);

  return (
    <div className={classNames(classes.container, className)}>
      <div ref={ref} className={classes.qrcode} onClick={onClick} aria-hidden />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    // border: "1px solid red",
    // height: 30,
    // padding: 10,
    backgroundColor: layoutDefaults.cardColor,
    // border: "1px solid #eee",
  },
  qrcode: {
    // backgroundColor: bgColor,
    // border: "1px solid #eee",
    display: 'flex',
    padding: layoutDefaults.bigVerticalMargin,
    borderRadius: layoutDefaults.radius,
  },
});

export { QRCode };
